<template>
    <div class="tab-select">
        <div
            :class="getOptionClasses(option)"
            v-for="option in safeOptions">
            <input
                type="radio"
                :name="safeName"
                :id="getOptionId(option)"
                :value="option.value"
                :checked="isOptionSelected(option)"
                @input="onOptionSelect(option)">
            <label :for="getOptionId(option)">
                {{ option.label }}
            </label>
        </div>
    </div>
</template>

<script>
    function genName() {
        const rand = Math.floor(Math.random() * 1000);
        return `tab_select_${rand}`;
    }

    export default {
        props: {
            options: {
                /**
                 * Can either be a string array or an object array. If a string
                 * array, the strings will be used as both the and value and
                 * labels. If an object array, the `value` and `label` can be
                 * different.
                 */
                type: Array,
                required: true,
            },
            value: {
                type: String,
                required: true,
            },
            name: {
                /**
                 * A name is required on the input elements to link the radio
                 * buttons together. You can supply a name with this prop, or
                 * you can allow the component to generate one.
                 */
                type: String,
                required: false,
            },
        },

        data() {
            return {
                generatedName: genName(),
            };
        },

        methods: {
            onOptionSelect(option) {
                this.$emit('input', option.value);
            },

            isOptionSelected(option) {
                return this.value === option.value;
            },

            getOptionId(option) {
                return `${this.generatedName}_${option.value}`;
            },

            getOptionClasses(option) {
                return {
                    option: true,
                    checked: this.isOptionSelected(option),
                };
            },
        },

        computed: {
            safeOptions() {
                return this.options.map(option => {
                    if (typeof option === 'string') {
                        return {
                            value: option,
                            label: option,
                        };
                    }
                    return {
                        value: option.value,
                        label: option.label || option.value,
                    };
                });
            },

            safeName() {
                return this.name || this.generatedName;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .tab-select {
        display: flex;
        position: relative;
    }

    .option {
        padding: 10px 10px 13px 10px;
        cursor: pointer;

        &:hover {
            background: #363636;
        }

        &.checked {
            padding-bottom: 10px;
            border-bottom: 3px solid #33ccff;
        }
    }

    input {
        // Hide completely
        position: fixed;
        opacity: 0;
        z-index: -1;
        cursor: inherit;
    }

    label {
        // Undo the default TTTC style
        margin: 0;
        position: static;
        cursor: inherit;
        font-weight: inherit !important;
    }
</style>



// WEBPACK FOOTER //
// index.vue?3376ae04